import Handsontable from "handsontable";
import {orderPriorityColors} from "../ExcelFormattedOrders/Settings";
import {getVehicleDetails, lrStatusColor} from "./Settings";

export function lrPrintRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]

  td.innerHTML = '<i class="fas fa-print" title="Print LR"/>'
  td.onclick = () => {
    self.openDownloadPDF(lr)
  }
}

export function lrNumberRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]
  let lrStatus = instance.getDataAtRowProp(row, 'status')

  td.style.color = lrStatusColor[lrStatus]
  td.innerHTML = ''

  let div = document.createElement('div');
  div.classList.add('order-num-txt')
  div.innerHTML = lr.lrNumber
  div.onclick = () => { self.editLR(lr.Order, lr) }
  td.appendChild(div)
}

export function orderNumberRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]
  let priority = lr.Order.priority

  td.innerHTML = '<span>'+value.substring(0, 3)+'</span>' +'<span>'+value.substring(3, 9)+'</span><br>' +
    '<span>'+value.substring(9, 11)+'</span>'+'<span>' + value.substring(11, value.length) + '</span>'

  if(orderPriorityColors[priority]){
    // td.style.color = orderPriorityColors[priority]
    td.children[0].style.color = orderPriorityColors[priority][0]
    td.children[1].style.color = orderPriorityColors[priority][1]
    td.children[3].style.color = orderPriorityColors[priority][1]
    td.children[4].style.color = orderPriorityColors[priority][0]
  }
  td.classList.add('order-num-txt')
  td.onclick = () => {
    self.editOrder(lr.Order)
  }
}

export function consignorRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]
  let city = lr.Consignor.address[0].city
  td.innerHTML = value + '<br>' + '<span style="color: #999999">' + city + '</span>'
  td.style.color = '#202020'
}

export function consigneeRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]
  let city = lr.Consignee.address[0].city
  td.innerHTML = value + '<br>' + '<span style="color: #999999">' + city + '</span>'
  td.style.color = '#202020'
}

export function pickupPointRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]
  let city = lr.PickupCompany.address[0].city
  td.innerHTML = value + '<br>' + '<span style="color: #999999">' + city + '</span>'
  td.style.color = '#202020'
}

export function dropPointRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]
  let city = lr.DropCompany.address[0].city
  td.innerHTML = value + '<br>' + '<span style="color: #999999">' + city + '</span>'
  td.style.color = '#202020'
}

export function orderDetailsRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                                   //When accessing original array
  let lr = self[array][pRow]
  let type = lr.Order?.materials?.type

  td.innerHTML = '<span style="color: gray">' + type + '</span>'+ '<br>' + value
}
export function truckDriverRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let lr = self[array][pRow];
  let driverMobile = getVehicleDetails(lr.Order, lr.transportVehicle, 'driverMobile');

  td.innerHTML = value + '<br>' + '<span style="color: #999999">' + driverMobile + '</span>'
  td.style.color = '#202020'
}
export function lrStatusRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  td.style.color = lrStatusColor[value]
}
export function actionRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row);                                   //When accessing original array
  let lr = self[array][pRow];
  let lrStatus = instance.getDataAtRowProp(row, 'status')
  if(lrStatus === 'Performa'){
    td.innerHTML = 'Cancel LR'
    td.classList.add('action-text')
    td.onclick = () => {
      self.onChangeLRStatus(lr)
    }
  }else td.onclick = null;
}
